import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DescriptionListModel } from '../../models/description-list-item-model';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

export type DescriptionListDialogData = {
    title: string;
    descriptionList: DescriptionListModel;
};

/**
 * Dialog that renders a {@link DescriptionListModel} inside {@link SharedDialogShellComponent}.
 *
 * Not exported from `public-api.ts`; opened only via {@link DescriptionListDialogService}.
 */
@Component({
    selector: 'lib-description-list-dialog',
    imports: [SharedDialogShellComponent],
    templateUrl: './description-list-dialog.component.html',
    styleUrl: './description-list-dialog.component.scss',
})
export class DescriptionListDialogComponent {
    private readonly data = inject<DescriptionListDialogData>(MAT_DIALOG_DATA);

    private readonly translateService = inject(TranslateService);

    protected get dialogShellConfig(): SharedDialogShellConfig {
        return {
            title: this.data.title,
            cancelLabel: this.translateService.instant('shared.buttons.close'),
        };
    }

    protected descriptionListConfig: DescriptionListModel =
        this.data.descriptionList;
}
